
import { Component, Vue } from "vue-property-decorator";
import ConfigService from "@/services/ConfigService";
@Component
export default class mReferences extends Vue {
  configService = ConfigService;
}
